import { IIconBase } from '..'

const uncheckedModalIcon = ({
  color = 'white',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='16' height='16' rx='4' fill={color} />
      <rect
        x='0.5'
        y='0.5'
        width='15'
        height='15'
        rx='3.5'
        stroke='black'
        strokeOpacity='0.15'
      />
    </svg>
  )
}

export default uncheckedModalIcon
